import { BOARD_POST_COOLDOWN_MS } from "./constants";

export function getGuestPostCooldownMs(messages, dancerId, isHosting) {
  if (isHosting || !dancerId) return 0;
  const mine = (messages || []).filter((m) => m.is_mine);
  if (!mine.length) return 0;
  const latest = mine.reduce((max, m) => {
    const t = new Date(m.created_at).getTime();
    return t > max ? t : max;
  }, 0);
  const remaining = BOARD_POST_COOLDOWN_MS - (Date.now() - latest);
  return remaining > 0 ? remaining : 0;
}
